import { UpdateRelationPcodeService } from './api-services/update_relation_pcode.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { KYMW0600Component } from './kymw0600.component';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { GetTargetRelationPcodeGoodsInfoService } from './api-services/get_target_relation_pcode_goods_info.service';
import { GetCandidateListInfoService } from './api-services/get_candidate_list_info.service';
/**
 * 関連商品設定画面　モジュール設定クラス
 *
 * @export KYMW0600Module
 * @class KYMW0600Module
 */
@NgModule({
  imports: [
    CommonModule,
    PlessSharedModule,
    FormsModule,
    WjNavModule,
    WjGridModule,
    WjInputModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW0600Component,
  ],
  providers: [
    GetTargetRelationPcodeGoodsInfoService,
    GetCandidateListInfoService,
    UpdateRelationPcodeService
  ],
})

export class KYMW0600Module { }
